import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import VehicleHiresTable from './VehicleHiresTable';
const Page = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsx(VehicleHiresTable, {}) }));
};
export default Page;
